<template>
    <div class="user-avatar">
        <background-loader :background="settings.background" :settings="settings" :key="settings.background" />
        <body-loader :body="settings.body" :settings="settings" :key="settings.body" />
        <eyes-loader :eyes="settings.eyes" :settings="settings" :key="settings.eyes" />
        <cloth-loader :cloth="settings.cloth" :settings="settings" :key="settings.cloth" />
        <mouths-loader :mouth="settings.mouth" :settings="settings" :key="settings.mouth" />
        <hair-loader :hair="settings.hair" :settings="settings" :key="settings.hair" />
    </div>
</template>

<script>
    import BodyLoader from './Bodies/BodyLoader';
    import EyesLoader from './Eyes/EyesLoader';
    import ClothLoader from './Cloths/ClothLoader';
    import MouthsLoader from './Mouths/MouthsLoader';
    import HairLoader from './Hair/HairLoader';
    import BackgroundLoader from './Background/BackgroundLoader';

    export default {
        name: 'UserAvatarView',
        components: { BackgroundLoader, HairLoader, MouthsLoader, ClothLoader, BodyLoader, EyesLoader },
        props: {
            settings: {
                type: Object,
                required: true,
            },
        },
    }
</script>

<style scoped>
    .user-avatar {
        height: 100%;
        width: 100%;
        position: relative;
    }

    .user-avatar > * {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }
</style>
